import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'

import { actions } from 'modules/home/HomeReducer'
import * as HomeSelector from 'modules/home/HomeSelector'
import { unserializeText, dateFormat, padEnd } from 'utils'
import styles from './Article.module.sass'

const { getLoadingArticle, getArticle } = HomeSelector

const Article = () => {
  const dispatch = useDispatch()
  const isLoading = useSelector(getLoadingArticle)
  const article = useSelector(getArticle)

  const startP = article.body?.startsWith('<p>')
  const startDiv = article.body?.startsWith('<div')
  const includeDiv = article.body?.includes('</div>')
  const isHTML = startP || startDiv || includeDiv
  let textHTML = ''
  if (isHTML) {
    if (startP) {
      textHTML = article.body.substring(3).split('<p>')
      textHTML =
        '<p class="article_p">' +
        textHTML
          .join('<p>')
          .replaceAll(
            '<p><p style="text-align:center;',
            '<p style="text-align:center;'
          )
          .replace(/<p>Reference:/i, '<p class="article_reference">REFERENCE:')
          .replace(/<p>Source:/i, '<p class="article_source">SOURCE:')
          .replaceAll('<p>', '<p class="article_p">')
    }
    if (startDiv) {
      const date =
        dateFormat(
          Number(padEnd(String(article.publication_date), 13, '0')),
          'MMM D, YYYY'
        ) + ' - '
      textHTML = article.body.substring(4).split('<div>')
      textHTML = date + '<div' + textHTML.join('<div>')
    }
    if (includeDiv) {
      const date = dateFormat(
        Number(padEnd(String(article.publication_date), 13, '0')),
        'MMM D, YYYY'
      )
      textHTML = article.body.split('<div class="PSL_LABEL">')
      textHTML.shift()
      textHTML =
        date +
        '<p><br/><b>' +
        textHTML.join('<p><br/><b>').replaceAll('</div>', '</p></b>')
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    dispatch(actions.setSearchTerm(''))
    dispatch(actions.setSearchPanel(false))

    let payload = {
      human_url: window.location.pathname.split('/article/')[1]
    }
    dispatch(actions.requestArticle(payload))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname])

  return (
    <div className={styles.container}>
      <Link to={'/'}>
        <p
          className={styles.backTxt}
          dangerouslySetInnerHTML={{ __html: '< Back' }}
        />
      </Link>
      {isLoading ? (
        <Skeleton count={25} />
      ) : (
        <>
          <h2 className={styles.h2}>{article.title}</h2>
          <p className={styles.author}>
            {(unserializeText(article.extra_fields?.authors) || [])
              .slice(0, 4)
              .map(author =>
                author.LastName?.length
                  ? `${author.ForeName} ${author.LastName}`
                  : `${author.ForeName}`
              )
              .join(', ')}
          </p>
          <p className={styles.citation}>{article.extra_fields?.citation}</p>
          {isHTML ? (
            <>
              <p
                className={styles.body}
                dangerouslySetInnerHTML={{
                  __html: textHTML
                }}
              ></p>
              {startDiv && article.tags.journal?.name && (
                <p className="article_source">
                  SOURCE: {article.tags.journal?.name}
                </p>
              )}
            </>
          ) : (
            <>
              <p className={styles.body}>
                {dateFormat(
                  Number(padEnd(String(article.publication_date), 13, '0')),
                  'MMM D, YYYY'
                )}
                {' - '}
                {article.body}
              </p>
              <p className="article_source">
                SOURCE: {article.extra_fields?.credit}
              </p>
            </>
          )}
        </>
      )}
    </div>
  )
}

Article.propTypes = {}

export default Article
